module.exports = __webpack_public_path__ + "img/service-tab-img3.8040714e.png";